
// @ts-check

import React from "react";

import "../styles/App.css";

import NamedBuildingInfoScreen from './NamedBuildingInfoScreen';


/**
 * @typedef {import('./coreTypes').CampaignSplashInfo} CampaignSplashInfo
 * @typedef {import('./coreTypes').JSX} JSX
 */


/**
 * @param {{ top: CampaignSplashInfo, bottom: ?CampaignSplashInfo }} props 
 * @returns {JSX}
 */
function NamedBuildingScreen(props) {
	if (props.bottom === null) {
		return (
			<div className="top-container-root">
				<div style={{ "width": '90%', "height": '42.5%', position: 'absolute', top: '5%', right: 0, }}>
					<NamedBuildingInfoScreen 
						title={props.top.title} 
						info={props.top.info} 
						image={props.top.image} 
						mirrored={false}
						narrow={true} />;
				</div>
			</div>);
	}
	else
		return (
			<div className="top-container-root">
				<div style={{ "width": '90%', "height": '42.5%', position: 'absolute', top: '5%', right: 0, }}>
					<NamedBuildingInfoScreen 
						title={props.top.title} 
						info={props.top.info} 
						image={props.top.image} 
						mirrored={false}
						narrow={true} />;
				</div>
				<div style={{ "width": '90%', "height": '42.5%', position: 'absolute', bottom: '5%', left: 0, }}>
					<NamedBuildingInfoScreen 
						title={props.bottom.title} 
						info={props.bottom.info} 
						image={props.bottom.image} 
						mirrored={true}
						narrow={true} />;
				</div>
			</div>);
};

export default NamedBuildingScreen;
